/**
 * início's 2x2 grid of suggested questions (Figma `LrdQopN1jNWKJFWxOkn0IY`
 * node `362:14912`, layer "Vazio / grade 2x2 de perguntas sugeridas"). Takes
 * no campaign data: see `suggestionMessages.ts` for why the copy is fixed.
 */

import { MapPinned, Megaphone, Share2, Users, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { st, type SuggestionMessageKey } from './suggestionMessages';

interface SuggestionCard {
  icon: LucideIcon;
  categoryKey: SuggestionMessageKey;
  questionKey: SuggestionMessageKey;
}

const CARDS: SuggestionCard[] = [
  { icon: Megaphone, categoryKey: 'pautas.category', questionKey: 'pautas.question' },
  { icon: Share2, categoryKey: 'amplification.category', questionKey: 'amplification.question' },
  { icon: MapPinned, categoryKey: 'territory.category', questionKey: 'territory.question' },
  { icon: Users, categoryKey: 'accounts.category', questionKey: 'accounts.question' },
];

export function Suggestions(props: { onAsk: (question: string) => void }): ReactNode {
  return (
    <div className="grid w-full grid-cols-1 items-start gap-3 pt-2 sm:grid-cols-2">
      {CARDS.map((card) => {
        const question = st(card.questionKey);
        return (
          <button
            key={card.questionKey}
            type="button"
            onClick={() => props.onAsk(question)}
            className="flex flex-col items-start gap-2 rounded-xl border border-border bg-card p-4 text-left shadow-xs outline-none hover:bg-accent focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50"
          >
            <span className="flex items-center gap-1.5 text-label-xs text-muted-foreground">
              <card.icon aria-hidden className="size-3.5" />
              {st(card.categoryKey)}
            </span>
            <span className="text-body text-foreground">{question}</span>
          </button>
        );
      })}
    </div>
  );
}
